import { Box, Typography } from "@material-ui/core";

import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useField } from "react-final-form";
import { useRecordContext } from "ra-core";

const useStyles = makeStyles((theme) => ({
  rowContainer: {
    display: "grid",
    gridTemplateColumns: "150px auto",
    width: "100%",
    // gridGap: 5,
    alignItems: "center",
    marginTop: 15,
    marginBottom: 15,
    // marginLeft: 20,
  },
  textStyle: { fontSize: 16 },
  textField: {
    width: 300,
  },
}));
const HashtagsInput = () => {
  const classes = useStyles();
  const {
    input: { onChange, value },
  } = useField("hashtags");
  const record = useRecordContext();
  return (
    <Box className={classes.rowContainer}>
      <Typography className={classes.textStyle}>Hashtags</Typography>

      <TextField
        className={classes.textField}
        value={value}
        source="hashtags"
        onChange={(e) => {
          // console.log(e.target.value);
          onChange(e.target.value);
        }}
        defaultValue={record.hashtags?.join(",") ?? ""}
      />
    </Box>
  );
};

export default HashtagsInput;
